export default __webpack_public_path__ + "static/media/pic3.b7644c36.jpg";